import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mangomahotsavmorachichincholi() {



    const cardData =
    {
        keyword: 'Mango Mahotsav Morachi Chincholi',
        heading: 'Anand Krushi Paryatan Kendra: Mango Mahotsav Morachi Chincholi',
        headingDescription: 'Celebrate the luscious sweetness of the season with an unforgettable Mango Mahotsav at Anand Krushi Paryatan Kendra, the ideal Mango Mahotsav Morachi Chincholi venue just 55 km from Pune. This charming 40-acre agri-tourism destination in Morachi Chincholi merges rural charm with festive flair in an eco-friendly, scenic setup. Enjoy a mango-themed extravaganza featuring seasonal mango displays and tastings—featuring popular varieties like Alphonso, Kesar, and Totapuri. Complementing the fruity fiesta are traditional and leisurely activities: bullock cart and tractor rides, horse riding, boating, swimming, refreshing rain-dance sessions, village games, puppet shows, and magic performances.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Farm‑Fresh Mango Tasting",
    "description": "Indulge in unlimited tasting of seasonal mango varieties freshly plucked from orchards—sweet, juicy, and bursting with flavour."
  },
  {
    "title": "Live Mango Plucking Experience",
    "description": "Stroll through lush mango trees and hand-pick your own mangoes straight from the source—a fun, engaging activity for all ages."
  },
  {
    "title": "Mango Cookery Workshops",
    "description": "Learn to make traditional treats like aamras-puri, mango barfi, pickles, panna, and more under the guidance of local cooks."
  },
  {
    "title": "Cultural Performances & Music",
    "description": "Enjoy folk music, dance, and lively performances that celebrate the mango season with colour and energy."
  },
  {
    "title": "Agro‑Tourism Activities",
    "description": "Combine mango fun with tractor rides, pottery, splash pools, and dairy demos at Anand Krushi Paryatan for a wholesome day out."
  }
],




"services": [
  {
    "name": "Seasonal Mango Festival in Morachi Chincholi",
    "description": "Celebrate the king of fruits at Anand Krushi Paryatan Kendra’s seasonal Mango Festival. This summer event is packed with fun—fresh mango tastings, cultural shows, and farm activities—making it a must-visit for mango lovers and families alike."
  },
  {
    "name": "Organic Mango Tasting Events",
    "description": "Savor the natural sweetness of pesticide-free, farm-grown mangoes straight from our orchards. Join our tasting sessions featuring multiple varieties like Alphonso, Kesar, and Langda, freshly plucked for an authentic farm-to-mouth experience."
  },
  {
    "name": "Mango-Themed Farm Experiences",
    "description": "From mango plucking to orchard walks and games, the entire farm turns into a mango wonderland during summer. Families can enjoy rural life with a delicious tropical twist at Anand Krushi Paryatan Kendra."
  },
  {
    "name": "Mango Farm Tours Near Pune",
    "description": "Escape city heat and head to the countryside for a mango farm tour. Learn how mangoes are grown, harvested, and stored—followed by fresh tastings and time to relax in nature."
  },
  {
    "name": "Family Mango Events in Morachi Chincholi",
    "description": "Bring the whole family for a refreshing day of food, fun, and rural charm. The mango festival features child-friendly games, safe open spaces, and sweet treats like Aamras, mango ice cream, and more."
  },
  {
    "name": "Cultural Shows During Mango Festival",
    "description": "Enjoy folk dances, musical performances, and storytelling rooted in Maharashtrian culture, all hosted alongside the farm’s mango celebration. A complete experience for tourists and locals alike."
  },
  {
    "name": "Aamras Parties in Summer",
    "description": "Nothing beats a cool bowl of Aamras on a hot day! Anand Krushi Paryatan Kendra hosts open-air Aamras parties with unlimited servings and traditional accompaniments like puris, bhakri, and thecha."
  },
  {
    "name": "Mango Cooking Classes and Food Stalls",
    "description": "Discover unique ways to enjoy mangoes through live cooking demos and stalls selling aam panna, mango pickles, desserts, and regional specialties prepared with fresh local produce."
  },
  {
    "name": "Mango-Based Games and Contests",
    "description": "From mango eating challenges to quiz contests and mango seed art, we offer fun, interactive games that make the Mango Festival exciting for both kids and adults."
  },
  {
    "name": "Local Mango Produce Stalls",
    "description": "Support local farmers by purchasing farm-fresh mangoes, pickles, pulp, and processed products directly from our stalls—straight from tree to your home."
  },
  {
    "name": "Kids Mango Festival Events",
    "description": "Dedicated kids’ zones feature mango-themed craft workshops, treasure hunts, storytelling sessions, and safe play spaces—making the mango festival enjoyable for the little ones too."
  },
  {
    "name": "Mango Tree Plantation Experience",
    "description": "Get your hands dirty and contribute to the environment by planting your own mango sapling at the farm. Participants receive a name tag and periodic growth updates about their tree."
  },
  {
    "name": "Summer Celebration Near Pune",
    "description": "Anand Krushi Paryatan Kendra transforms into a summer retreat with shaded dining zones, cooling drinks, water games, and fresh fruits—a delightful seasonal escape just an hour from Pune."
  },
  {
    "name": "Agro-Tourism Mango Festival",
    "description": "More than just a fruit fest—our Mango Mahotsav includes guided farm tours, seed-saving workshops, organic growing insights, and local food sampling as part of the larger agro-tourism experience."
  },
  {
    "name": "Group Events During Mango Mahotsav",
    "description": "We host mango-themed team outings, school trips, and large family get-togethers with customized food, farm games, and cultural add-ons for a full-day mango celebration in the countryside."
  }
],
"tableData": [
  ["Seasonal Mango Festival in Morachi Chincholi", "- Organic Mango Tasting Events"],
  ["Mango-Themed Farm Experiences", "- Mango Farm Tours Near Pune"],
  ["Family Mango Events in Morachi Chincholi", "- Cultural Shows During Mango Festival"],
  ["Aamras Parties in Summer", "- Mango Cooking Classes and Food Stalls"],
  ["Mango-Based Games and Contests", "- Local Mango Produce Stalls"],
  ["Kids Mango Festival Events", "- Mango Tree Plantation Experience"],
  ["Summer Celebration Near Pune", "- Agro-Tourism Mango Festival"],
  ["Group Events During Mango Mahotsav", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Seasonal Mango Celebration",
    "WhyChoosedescription": "Mango Mahotsav is a vibrant festival held during the mango season in Morachi Chincholi, celebrating the king of fruits with a variety of activities and fresh mango delicacies. It’s an excellent opportunity to experience the local agricultural culture and rural festivities."
  },
  {
    "WhyChooseheading": "Fresh Mango Picking Experience",
    "WhyChoosedescription": "Visitors get the unique chance to pick ripe mangoes directly from the orchards, engaging closely with nature and understanding traditional farming practices. This hands-on activity is fun and educational for families and nature lovers."
  },
  {
    "WhyChooseheading": "Delicious Mango-based Cuisine",
    "WhyChoosedescription": "The festival features authentic Maharashtrian mango dishes such as aamras, mango shakes, pickles, and desserts, offering a rich culinary experience that highlights the diversity of mango usage in local food."
  },
  {
    "WhyChooseheading": "Cultural Programs and Folk Entertainment",
    "WhyChoosedescription": "Enjoy traditional music, folk dance, and other cultural performances that bring the vibrant spirit of rural Maharashtra alive, making the festival a joyful experience for visitors of all ages."
  },
  {
    "WhyChooseheading": "Agro-Tourism and Village Life",
    "WhyChoosedescription": "Mango Mahotsav is hosted at agro-tourism centers like Anand Krushi Paryatan Kendra, where guests can also enjoy tractor rides, bullock carts, and explore organic farms, providing a wholesome rural retreat."
  },
  {
    "WhyChooseheading": "Ideal Time for Family Outing",
    "WhyChoosedescription": "Taking place from April to July, the festival offers perfect weather and a lively environment for families and groups to relax, explore, and celebrate the mango harvest in a natural, scenic setting."
  }
]


















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What is the Mango Mahotsav at Morachi Chincholi?',
    answer: 'Mango Mahotsav is a vibrant festival celebrating the mango season with various mango varieties, delicious mango-based dishes, cultural performances, and workshops at Morachi Chincholi.',
  },
  {
    id: 'FAQ2',
    question: 'When is the Mango Mahotsav held?',
    answer: 'The festival is typically held from late April to June, coinciding with the peak mango season.',
  },
  {
    id: 'FAQ3',
    question: 'Where exactly is the Mango Mahotsav held?',
    answer: 'It is held at Anand Krushi Paryatan Kendra in Morachi Chincholi, about 50 km from Pune.',
  },
  {
    id: 'FAQ4',
    question: 'What activities are available during the Mango Mahotsav?',
    answer: 'Visitors can enjoy mango tasting sessions, cooking workshops, cultural programs, farm tours, and entertainment for all age groups.',
  },
  {
    id: 'FAQ5',
    question: 'Are there special food offerings during the festival?',
    answer: 'Yes! The festival features a variety of mango-based dishes, desserts, and beverages made from fresh local mangoes.',
  },
  {
    id: 'FAQ6',
    question: 'Is accommodation available during the festival?',
    answer: 'Yes, many packages include comfortable accommodation options at Anand Krushi Paryatan Kendra or nearby.',
  },
  {
    id: 'FAQ7',
    question: 'Can families attend the Mango Mahotsav?',
    answer: 'Absolutely! The festival is family-friendly with activities and entertainment suitable for all ages.',
  },
  {
    id: 'FAQ8',
    question: 'How can I book a visit to the Mango Mahotsav?',
    answer: 'You can contact the organizers via phone or email for booking and package details.',
  },
  {
    id: 'FAQ9',
    question: 'Is the Mango Mahotsav eco-friendly?',
    answer: 'Yes, the festival promotes sustainable and eco-friendly practices, focusing on natural farming and local produce.',
  },
  {
    id: 'FAQ10',
    question: 'What is the best way to reach Morachi Chincholi for the festival?',
    answer: 'Morachi Chincholi is accessible by car or taxi from Pune, approximately a 1.5-hour drive via Alandi or Chakan.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshpande, Pune',
    feedback: "The Mango Mahotsav at Morachi Chincholi was a delightful experience! The mango varieties were incredible, and the cultural events made it a memorable visit.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Joshi, Pune',
    feedback: "A perfect summer outing with family. Loved tasting so many kinds of mangoes and learning about their cultivation. Highly recommended!",
    rating: 5,
  },
];





















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mango Mahotsav Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/mango-mahotsav-morachi-chincholi.jpg",
  "description": "Celebrate the seasonal Mango Mahotsav at Morachi Chincholi with organic mango tasting, farm tours, cultural shows, aamras parties, mango cooking classes, and fun mango-themed activities perfect for families and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1725"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "850",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/mango-mahotsav"
  }
};




    return (
        <div>
<Helmet>
  <title>Mango Mahotsav Morachi Chincholi | Seasonal Mango Festival & Farm Experiences</title>
  <meta 
    name="description" 
    content="Join the Mango Mahotsav at Morachi Chincholi featuring organic mango tasting, farm tours, cultural shows, aamras parties, cooking classes, and fun mango-themed games and contests for all ages." 
  />
  <meta 
    name="keywords" 
    content="Seasonal mango festival in Morachi Chincholi, Organic mango tasting events, Mango-themed farm experiences, Mango farm tours near Pune, Family mango events in Morachi Chincholi, Cultural shows during mango festival, Aamras parties in summer, Mango cooking classes and food stalls, Mango-based games and contests, Local mango produce stalls, Kids mango festival events, Mango tree plantation experience, Summer celebration near Pune, Agro-tourism mango festival, Group events during Mango Mahotsav" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mangomahotsavmorachichincholi;